<app-pop-up
	[id]="popUpId"
	[options]="{}"
>
	<div
		class="popup popup-biometrics-registration"
		inCutVersionActive
	>
		<app-loader
			#loaderStep1
			[context]="'element'"
			[isActive]="false"
		></app-loader>
		<button
			class="button-reset close"
			type="button"
			(click)="close()"
		></button>

		<div class="popup__content popup-biometrics-registration__content">
			<!-- <h3 class="popup__header">
      Вход в Русский Стандарт Онлайн
    </h3> -->
			<div class="popup__body">
				@if (isOpen) {
					<app-biometrics-registration-wizard
						#wizard
						[biometricsRegistrationPopUpComponent]="this"
						[biometricsRegistrationErrorPopUpComponent]="
							biometricsRegistrationErrorPopUpComponent
						"
						[biometricsRegistrationSuccessPopUpComponent]="
							biometricsRegistrationSuccessPopUpComponent
						"
					></app-biometrics-registration-wizard>
				}
			</div>
			<!-- <div class="popup__footer popup-biometrics-registration__footer">

  </div> -->
		</div>
	</div>
</app-pop-up>
